module.exports = __webpack_public_path__ + "static/img/Three of Cups.e835c7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Three of Cups.jpg
// module id = 1325
// module chunks = 0